import { useTranslation } from "react-i18next";
import React from "react";
const PolicyEdit = () => {
  const { t } = useTranslation();
  return <div>{t("PolicyUpdate")}</div>;
};
export default PolicyEdit;
